import React, {  useReducer } from 'react';
import ButtonCollection from './builder/ButtonCollection';

import Input from './builder/Input';
import ActionButton from './builder/ActionButton';
import Model from './builder/Model';
import { isEmpty } from '../lib/ep';
import ContentSelector from './Form/ContentSelector';

const reducer = (state, action) => {
    switch (action.type) {
        case 'CHANGE':

            const article = { 
                ...state.article,
                [action.k]:action.v 
            };

            if (article.total > 0 && article.quantity > 0) {
                article.unit_price = Math.round(article.total / article.quantity,2);
                
            }

            return { article,errors:{} };
        case 'ERROR':
            return { ...state,errors:{...state.errors,...action.payload} };
        default:
            return state;
    }
}

const AddArticle = ({ json, ...props }) => {
    const close = ContentSelector.useCloseAction();   
    const [state, dispatch] = useReducer(reducer, {
        article:{
            article:"",
            discount_amount: 0,
            quantity: 1,
            sku: "",
            subtotal:0 ,
            tax_amount: 0,
            tax_type: null,
            total: 0,
            unit_price: 0
        },
        errors:{}
    });
    
    const change = (k, v) => { 
        dispatch({ type:'CHANGE', k, v });
    }

    const addArticle = () => {
        if (isEmpty(state.article, 'article')) {
            dispatch({ type:'ERROR', payload:{article:"Article is required"}});
            //setErrors({article:"Article is required"});
            return;
        }
        if (isEmpty(state.article, 'quantity') || state.article.quantity <= 0) {
            dispatch({ type:'ERROR', payload:{quantity:"Quantity is required"}});
            //setErrors({quantity:"Quantity is required"});
            return;
        }
        if (isEmpty(state.article, 'total') || state.article.total <= 0) {
            dispatch({ type:'ERROR', payload:{total:"Total is required"}});
            return;
        }

        if (/\,/.test(state.article.total)) {
            dispatch({ type:'ERROR', payload:{total:"Use . as a decimal separator"}});
            return;
        }

        json.line_items.push(state.article);
        if (props.onSave != undefined) props.onSave(json);
        close();
    }

	return (
		<>
        <Model model={state.article} change={change} errors={state.errors}>
            <Input name="article" _class={{size:60}}>Article</Input>
            <Input name="sku" _class={{size:60}}>SKU</Input>
            <Input name="quantity" _class={{size:60}}>Quantity</Input>
            <Input name="total" _class={{size:60}}>Amount</Input>
        </Model>
        <ButtonCollection>
            <ActionButton onClick={addArticle}>Add</ActionButton>
            <ActionButton 
                color='red'
                icon='knk-off'
                onClick={() => close()}
                >Cancel</ActionButton>
        </ButtonCollection>
        </>
		
	)
};

export default AddArticle;